import {
  Box,
  Center,
  Divider,
  HStack,
  Image,
  Link,
  Text,
  useColorMode,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import * as React from "react";
import styles from "./Footer.module.css";
import { footerLinks } from "./_data";

const App = (props: any) => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <>
      <Box as="footer" id="footer" className={styles.footer}>
        <Divider marginBottom="12px" />

        <Box
          width="100%"
          display="flex"
          justifyContent={"space-between"}
          pb="12px"
          pl="20px"
          pr="20px"
        >
          <Image
            src="/images/reddot/red-dot-logo.svg"
            alt="Option Tracker"
            width="230px"
            pr="10px"
          />
          <Wrap id="bottom" alignItems={"center"} display={"flex"}>
            {footerLinks.map((link, idx) => (
              <WrapItem key={idx}>
                <Box
                  pr="10px"
                  as="a"
                  fontSize="14px"
                  color="var(--white)"
                  fontWeight="400"
                  href={link.href}
                >
                  {link.label}
                </Box>
              </WrapItem>
            ))}
          </Wrap>
        </Box>
      </Box>
      <Box
        as="footer"
        id="footer"
        className={styles.footer}
        backgroundColor={"var(--bg)"}
        w="100%"
      >
        <Divider marginBottom="12px" />
        <HStack spacing={"16px"} pb="16px" wrap={"wrap"} w="100%">
          <VStack spacing="10px" w="100%" pb="8px">
            <Text color="var(--gray)" fontSize="10px" fontWeight="600">
              Option Tracker around the web
            </Text>
            <HStack spacing="12px" wrap="wrap" justifyContent="center" w="100%">
              <Link
                href="https://dang.ai"
                isExternal
                rel="dofollow noopener noreferrer"
                title="Verified on DANG!"
              >
                <img
                  src="https://assets.dang.ai/badges/dang-verified-dark.png"
                  alt="Verified on DANG!"
                  width="130"
                  height="47"
                  style={{ display: "block", maxWidth: "130px", height: "auto" }}
                />
              </Link>
              <Link href="https://fazier.com" isExternal fontSize="10px" color="var(--gray)">
                Fazier
              </Link>
              <Link href="https://turbo0.com" isExternal fontSize="10px" color="var(--gray)">
                Turbo0
              </Link>
              <Link href="https://www.toolpilot.ai" isExternal fontSize="10px" color="var(--gray)">
                Toolpilot
              </Link>
              <Link href="https://wired.business" isExternal fontSize="10px" color="var(--gray)">
                Wired Business
              </Link>
              <Link href="https://www.foundrlist.com" isExternal fontSize="10px" color="var(--gray)">
                FoundrList
              </Link>
              <Link href="https://startupfa.me" isExternal fontSize="10px" color="var(--gray)">
                Startup Fame
              </Link>
            </HStack>
          </VStack>
          <HStack
            spacing={"16px"}
            pb="16px"
            wrap={"wrap"}
            justifyContent={"center"}
            w="100%"
          >
            <Text color="var(--gray)" fontSize={"10px"}>
              UI/UX design supported by{" "}
              <Link href="https://spaceberrystudio.com/optr">
                Spaceberry Studio
              </Link>
            </Text>
            <Text fontSize={"10px"} color="var(--gray)">
              © Option Tracker Ltd
            </Text>
          </HStack>

          <Text
            fontSize={"10px"}
            color="var(--gray)"
            textAlign={"center"}
            w="100%"
          >
            Charting is provided by TradingView, a global analytical platform
            catering to traders and investors worldwide, facilitating
            comprehensive research of the{" "}
            <a href="https://www.tradingview.com/markets/currencies/">
              forex market
            </a>
            .
          </Text>
        </HStack>
      </Box>
    </>
  );
};

export default App;
